 export class ZoneArray
{
  value!: string;
  display!: string;
}